<template>
    <div class="marking-details container">
        <el-card shadow="never" class="marking-details-header">
            <h4>{{examInfo.examName}}</h4>
            <div>本试卷共7题，共5种类型题目；总分7分。</div>
        </el-card>
        <el-card shadow="never" class="marking-details-footer">
            <el-row :gutter="20">
                <el-col :span="18">
                    <el-tabs type="card" v-model="curQType">
                        <el-tab-pane
                                    v-for="(type, typeIdx) in questionTabs" :label="`${type.name}(${oQuestions[type.id].quantity})`" :key="typeIdx"
                                    :name="String(typeIdx)">
                        </el-tab-pane>
                        <div>
                            <div class="marking-details-topic">
                                <span v-text="curQuestionInfo.name"></span>：
                                共<span v-text="curQuestionInfo.quantity"></span>题，
                                <span v-text="(curQuestionInfo.totalScore / curQuestionInfo.quantity).toFixed(2)"></span>分/题，
                                共<span v-text="curQuestionInfo.totalScore"></span>分
                            </div>
                            <div class="question-list">
                                <div class="question-item" v-for="question in curQuestionInfo.list" :key="question.questionId" :id="`q_${question.questionId}`">
                                    <!-- 题干 -->
                                    <h4>Q{{question.questionNumber}}、<div v-html="question.fieldName"></div></h4>
                                    <div>
                                        <el-radio-group v-if="question.questionTypeId === 1" v-model="question.userAnswer" disabled>
                                            <el-radio v-for="(radio, radioKey) in question.content.choiceList" :key="radioKey" :label="radioKey">
                                                {{radioKey}}、{{radio}}
                                            </el-radio>
                                        </el-radio-group>
                                        <el-checkbox-group v-else-if="question.questionTypeId === 2" v-model="question.userAnswer" disabled>
                                            <el-checkbox v-for="(checkbox, checkboxKey) in question.content.choiceList" :key="checkboxKey" :label="checkboxKey">
                                                {{checkboxKey}}、{{checkbox}}
                                            </el-checkbox>
                                        </el-checkbox-group>
                                        <el-radio-group v-else-if="question.questionTypeId === 3" v-model="question.userAnswer" disabled>
                                            <el-radio label="T">正确</el-radio>
                                            <el-radio label="F">错误</el-radio>
                                        </el-radio-group>
                                        <div v-else-if="question.questionTypeId === 4">
                                            <div v-for="(answer, answerKey) in question.userAnswer" :key="answerKey">
                                                <el-input size="small" :value="answer" disabled></el-input>
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{question.userAnswer || '-'}}
                                        </div>
                                    </div>
                                    <div v-if="question.questionTypeId < 5">
                                        <h5>参考答案</h5>
                                        <div v-if="question.questionTypeId === 2">
                                            <span v-for="(answer, answerIdx) in question.answer" :key="answerIdx" v-text="answer"></span>
                                        </div>
                                        <div v-else-if="question.questionTypeId === 3" v-text="question.answer === 'T' ? '正确' : '错误'"></div>
                                        <div v-else-if="question.questionTypeId === 4">
                                            <p v-for="(answer, answerIdx) in question.answer" :key="answerIdx" v-text="answer"></p>
                                        </div>
                                        <div v-else v-text="question.answer"></div>
                                    </div>
                                    <div>
                                        <h5>本次得分</h5>
                                        <div>
                                            <el-input-number size="mini" :min="0" :max="question.questionPoint"
                                                            v-model="question.userPoint"
                                                            @change="handlePointChange($event, question.questionId)">
                                            </el-input-number>/{{question.questionPoint}}
                                        </div>
                                    </div>
                                    <div>
                                        <h5>题目解析</h5>
                                        <div v-html="question.analysis"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-tabs>
                </el-col>
                <el-col :span="6">
                    <div class="marking-right">
                        <div class="marking-right-header">
                            <el-button type="primary" @click="handleSubmit">提交阅卷</el-button>
                        </div>
                        <div class="marking-right-body">
                            <p>
                                <el-checkbox size="medium" v-model="spreadNo" @change="openNoReadCollapse">展示未阅卷的题目</el-checkbox>
                            </p>
                            <ul>
                                <li>
                                    <span style="background-color:#f3f3f4"></span>
                                    <i>未阅</i>
                                </li>
                                <li>
                                    <span style="background-color:#14b14e"></span>
                                    <i>已阅</i>
                                </li>
                            </ul>
                        </div>
                        <div class="marking-right-footer">
                            <el-collapse v-model="activeCollapse">
                                <el-collapse-item v-for="(type, typeIdx) in questionTabs" :key="typeIdx"
                                                :name="type.id"
                                                :title="`${type.name}(${oQuestions[type.id].quantity})`">
                                    <ul>
                                        <li v-for="question in oQuestions[type.id].list" :key="question.questionId"
                                            :class="{
                                                isRead: readQuestionIds.indexOf(question.questionId) > -1
                                            }">
                                            <a :href="`#q_${question.questionId}`" v-text="question.questionNumber" @click="handleQTypeChange(question.questionTypeId)"></a>
                                        </li>
                                    </ul>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <div class="back_top" @click="backTop">
            <span>
                <i class="el-icon-top"></i>
            </span>
        </div>
    </div>
</template>

<script>
import { formatQuestions } from '@/utils/exam'
import { getEtexamDetail, answersheet } from '@/api/exam/etexam';
import { getEtexampaperDetail } from '@/api/exam/etexampaper';
import { getEtquestiontypeList } from '@/api/exam/etquestiontype';
import { getUserExamHistory } from '@/api/exam/etuserexamhistory';
export default {
    data () {
        return {
            curQType: null, // 当前题型
            examInfo: {}, // 考试信息
            examRecordInfo: {}, // 考试记录信息
            paperInfo: {}, // 试卷信息
            questionTypeList: [], // 题目类型
            spreadNo: true, // 展开未阅卷的题目
            activeCollapse: [] // 默认展开的折叠面板
        };
    },
    computed: {
        oQuestions () {
            let arrQuestions = this.paperInfo.content || []
            let answerSheetItems = []
            if (this.examRecordInfo.answerSheet) {
                answerSheetItems = this.examRecordInfo.answerSheet.answerSheetItems || []
            }
            let oQuestions = {}
            this.questionTypeList.map(qType => {
                oQuestions[qType.id] = {
                    name: qType.name,
                    list: [], // 各题型的题目列表
                    totalScore: 0,
                    quantity: 0
                }
            })
            arrQuestions.map((question, questionIdx) => {
                let userAInfo = answerSheetItems.filter(item => {
                    return item.questionId === question.questionId
                })
                let userAnswer = ''
                let userPoint = ''
                if (userAInfo.length > 0) {
                    userAnswer = userAInfo[0].answer,
                    userPoint = userAInfo[0].point
                    switch (question.questionTypeId) {
                        case 2:
                            userAnswer = userAnswer.split('')
                            break;
                        case 4:
                            userAnswer = userAnswer.split(',')
                            break;
                        default:
                            break;
                    }
                }
                oQuestions[question.questionTypeId].list.push({
                    ...question,
                    questionNumber: questionIdx + 1,
                    userAnswer,
                    userPoint
                })
                oQuestions[question.questionTypeId].totalScore += question.questionPoint
                oQuestions[question.questionTypeId].quantity += 1
            })
            return oQuestions
        },
        questionTabs () {
            let tabs = []
            this.questionTypeList.map(type => {
                if (this.oQuestions[type.id].list.length > 0) {
                    tabs.push({
                        ...type
                    })
                }
            })
            return tabs
        },
        // 当前类型题目的信息
        curQuestionInfo () {
            let { curQType, questionTabs } = this
            let info = {
                name: '', // 题型名称
                quantity: 0, // 该题型题目个数
                totalScore: 0 // 题型总分
            }
            if (curQType && questionTabs.length > 0) {
                info = this.oQuestions[questionTabs[curQType].id]
            }
            return info
        },
        // 阅卷提交的answerSheet数据
        subAnswerSheet () {
            let { answerSheet } = this.examRecordInfo
            let { answerSheetItems } = answerSheet
            let newASItems = []
            answerSheetItems.map(item => {
                newASItems.push({
                    ...item,
                    right: item.point !== undefined ? item.point > 0 : null
                })
            })
            answerSheet = {
                ...answerSheet,
                answerSheetItems: newASItems
            }
            return answerSheet
        },
        // 已阅题目id列表
        readQuestionIds () {
            let arrId = []
            let { answerSheet } = this.examRecordInfo
            if (answerSheet) {
                let { answerSheetItems } = answerSheet
                answerSheetItems.map(item => {
                    if (item.point !== undefined) {
                        arrId.push(item.questionId)
                    }
                })
            }
            return arrId
        }
    },
    methods: {
        init () {
            this.getExamRecordInfo()
            this.getQuestionTypeList()
            this.getExamInfo()
        },
        // 回到顶部
        backTop() {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        },
        //监听滚动条变化
        handleScroll() {
            let scrollY =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            let scrollObj = document.querySelector('.marking-right');
            let scrollTab = document.querySelector('.el-tabs__header');
            let scrollBack = document.querySelector('.back_top');
            let scrollTabNav = document.querySelector('.el-tabs__nav');
            if (scrollY > 210) {
                scrollObj.style.position = 'fixed';
                scrollObj.style.width = '255px';
                scrollObj.style.top = '0';
                scrollTab.style.position = 'fixed';
                scrollBack.style.display = 'block';
                scrollTab.style.zIndex = '999';
                scrollTabNav.style.backgroundColor = '#f5f5f5';
                scrollTab.style.top = '0';
            } else {
                scrollObj.style.position = 'static';
                scrollObj.style.marginTop = '39px';
                scrollTab.style.position = 'static';
                scrollBack.style.display = 'none';
                scrollTabNav.style.backgroundColor = '#fff';
                scrollTab.style.marginTop = '0';
            }
        },
        getExamInfo () {
            let { id } = this.$route.params
            id = Number(id)
			getEtexamDetail(id).then(res => {
				this.examInfo = {
					...res,
					antiCheatingArr: (() => {
						let arr = res.antiCheating.split(',')
						arr.map((item, i) => {
							if (item === '1') {
								arr[i] = '题目乱序'
							} else if (item === '2') {
								arr[i] = '选项乱序'
							} else {
								let arr2 = item.split(':')
								arr[i] = `切屏 ${arr2[1]} 次强制交卷`
							}
						})
						return arr
					})()
				}
				this.getPaperInfo(res.examPaperId)
			})
        },
        // 获取题目类型列表
        getQuestionTypeList () {
            getEtquestiontypeList().then(res => {
                let arr = []
                res.map(item => {
                    arr.push({
                        ...item,
                        id: String(item.id)
                    })
                })
                this.questionTypeList = arr
            })
        },
        getExamRecordInfo () {
            let { recordId } = this.$route.params
            getUserExamHistory(recordId).then(res => {
                this.examRecordInfo = {
                    ...res,
                    answerSheet: JSON.parse(res.answerSheet)
                }
                this.openNoReadCollapse()
            })
        },
		// 获取试卷详情
		getPaperInfo (id) {
			getEtexampaperDetail(id).then(res => {
                let content = res.content ? formatQuestions(res.content) : []
                let answerSheet = res.answerSheet ? JSON.parse(res.answerSheet) : {}
                this.paperInfo = {
                    ...res,
                    content,
                    answerSheet
                }
			})
        },
        handlePointChange (val, questionId) {
            let index = null
            let question = this.examRecordInfo.answerSheet.answerSheetItems.filter((item, i) => {
                if (item.questionId === questionId) {
                    index = i
                }
                return item.questionId === questionId
            })
            if (question.length > 0) {
                this.$set(this.examRecordInfo.answerSheet.answerSheetItems[index], 'point', val)
            }
            this.openNoReadCollapse()
        },
        handleQTypeChange (typeId) {
            this.questionTabs.map(item => {
                if (item.id === String(typeId)) {
                    this.curQType = String(typeId - 1)
                }
            })
        },
        handleSubmit () {
            answersheet(this.subAnswerSheet).then(() => {
                let { id } = this.$route.params
                this.$message.success('阅卷成功')
                this.$router.replace({
                    name: 'testMarking',
                    params: { id }
                });
            })
        },
        // 当绑定值变化时触发的事件
        openNoReadCollapse (val = this.spreadNo) {
            if (val) {
                let { answerSheet } = this.examRecordInfo
                if (answerSheet) {
                    let noReads = []
                    let { answerSheetItems } = answerSheet
                    for (let i = 0; i < answerSheetItems.length; i++) {
                        let questionTypeId = String(answerSheetItems[i].questionTypeId)
                        if (answerSheetItems[i].point === undefined && noReads.indexOf(questionTypeId) < 0) {
                            noReads.push(questionTypeId)
                        }
                    }
                    this.activeCollapse = noReads
                }
            }
        }
    },
    created () {
        this.init();
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style lang="less">
.marking-details {
    .marking-details-footer {
        .el-tabs__item{
            font-size: 16px;
            font-weight: 600;
            padding:0 20px;
        }
        .el-tabs {
            &__header {
                z-index: 999;
                width: 805px;
                border: none;
            }
            &__nav {
                border: none;
                width: 100%;
            }
            &--card {
                & > .el-tabs__header {
                    .el-tabs__item {
                        border: none;
                    }
                }
            }
        }
        .marking-right {
            .marking-right-footer {
                .el-collapse-item {
                    &__header {
                        padding: 5px 10px;
                        height: 32px;
                        border-left: 1px solid #ebeef5;
                        border-right: 1px solid #ebeef5;
                        background-color: #f3f3f4;
                        margin-bottom: 20px;
                        border-radius: 4px;
                    }
                    &__wrap {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}
</style>

<style lang="less" scoped>
.marking-details {
    font-size: 14px;
    .marking-details-header {
        margin: 10px 0 25px 0;
        h4 {
            font-size: 14px;
            margin-bottom: 20px;
        }
        div {
            padding: 15px;
            margin-bottom: 20px;
            background-color: #fff;
            color: #8a6d3b;
            background-color: #fcf8e3;
            border: 1px solid #faebcc;
            border-radius: 4px;
        }
    }
    .back_top {
        display: none;
        position: fixed;
        width: 50px;
        height: 50px;
        bottom: 20px;
        right: 80px;
        text-align: center;
        font-size: 40px;
        background-color: #a3a5a9;
        color: #fff;
        cursor: pointer;
        opacity: 0.3;
        &:hover {
            opacity: 0.6;
        }
    }
    .marking-details-footer {
        min-height: 2000px;
        .marking-details-topic {
            padding: 15px;
            background-color: #f3f3f4;
            border: 1px solid #e7eaec;
        }
        .question-list {
            border-left: 1px solid #e7eaec;
            border-right: 1px solid #e7eaec;
            .question-item {
                padding: 40px;
                border-bottom: 1px solid #e7eaec;
                &:not(:last-child) {
                    margin-bottom: 12px;
                }
                > h4 {
                    line-height: 2em;
                }
                > div {
                    padding-left: 2em;
                    > h5 {
                        line-height: 2em;
                    }
                    > div {
                        padding-left: 2em;
                    }
                }
            }
        }
        .marking-right {
            margin-top: 39px;
            .marking-right-header {
                margin-bottom: 15px;
                padding: 15px;
                border: 1px solid #e7eaec;
                .el-button {
                    width: 100%;
                    height: 34px;
                    line-height: 10px;
                }
            }
            .marking-right-body {
                padding: 15px;
                border: 1px solid #e7eaec;
                p {
                    margin-bottom: 10px;
                }
                ul {
                    overflow: hidden;
                    li {
                        float: left;
                        line-height: 15px;
                        margin-right: 20px;
                        span {
                            float: left;
                            width: 16px;
                            height: 16px;
                            margin-right: 5px;
                        }
                        i {
                            font-style: normal;
                            float: left;
                        }
                    }
                }
            }
            .marking-right-footer {
                border: 1px solid #e7eaec;
                border-top: none;
                padding: 15px;
                .el-collapse {
                    border: none;
                    &-item {
                        margin-bottom: 10px;
                    }
                }
                ul {
                    li {
                        width: 23px;
                        height: 23px;
                        float: left;
                        margin: 2px;
                        background-color: #eee;
                        text-align: center;
                        line-height: 20px;
                        a {
                            width: 100%;
                            height: 100%;
                            display: inline-block;
                            color: #777;
                        }
                        &.isRead {
                            background-color: #14b14e;
                            a {
                                color: white;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>


